/**Modules */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { CampaignRoutingModule } from './campaign-routing.module';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { MatDatepickerModule } from '@angular/material/datepicker';

/**Components */
import {
  CampaignComponent,
  BasicDetailComponent,
  ImageUploadComponent,
  AdvanceDetailComponent,
  DescriptionComponent,
  RewardsComponent,
  PreviewComponent,
} from './components';
import { PopoverModule } from './ui-components/popover/popover.module';
import { AutoselectModule } from '../common/autoselect/autoselect.module';
import { ButtonModule } from '../common/button/button.module';
import { CaptchaModule } from '../common/captcha/captcha.module';
import { CardViewModule } from '../common/card-view/card-view.module';
import { DatepickerModule } from '../common/datepicker/datepicker.module';
import { EditorModule } from '../common/editor/editor.module';
import { HeaderModule } from '../common/header/header.module';
import { InputModule } from '../common/input/input.module';
import { IntlInputModule } from '../common/intl-input/intl-input.module';
import { PlaceAutocompleteModule } from '../common/place-autocomplete/place-autocomplete.module';
import { SacPurposeModule } from '../common/sac-purpose/sac-purpose.module';
import { SelectModule } from '../common/select/select.module';
import { PopoverLoaderModule } from '../common/popover-loader/popover-loader.module';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { PreviewFundraiserComponent } from '../common/preview-fundraiser/preview-fundraiser.component';
/**Common Modules Imported */
const AppCommonModules = [
  InputModule,
  ButtonModule,
  IntlInputModule,
  CardViewModule,
  CaptchaModule,
  DatepickerModule,
  SelectModule,
  AutoselectModule,
  EditorModule,
  PlaceAutocompleteModule,
  HeaderModule
];
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    AngularCropperjsModule,
    CampaignRoutingModule,
    SharedModule,
    SacPurposeModule,
    PopoverModule,
    PopoverLoaderModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatIconModule,
    MatDialogModule,
    ...AppCommonModules,
    PreviewFundraiserComponent
  ],
  declarations: [
    CampaignComponent,
    BasicDetailComponent,
    ImageUploadComponent,
    AdvanceDetailComponent,
    DescriptionComponent,
    RewardsComponent,
    PreviewComponent
  ],
  exports: [
    ImageUploadComponent
  ]
})
export class CampaignModule { }
